var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"mouse"}),_c('p',[_c('v-icon',{staticClass:"d-inline-block"},[_vm._v("mdi-chevron-double-down")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }